module.exports = __webpack_public_path__ + "img/6.207a5e2f.jpg";